<template>
  <div>
    <div>
      <span v-if="params.value">{{ params.value | toYMDHM }}</span
      ><span v-else>-</span>
    </div>
  </div>
</template>
<script>
export default {
  name: "CellRendererPlotDate",
  computed: {},
};
</script>

<style lang="scss" scoped></style>
